import React, { useState, useEffect } from 'react';
import HeroBanner from '../components/HeroBanner';
import ProductGrid from '../components/ProductGrid';
import QuemSomos from '../components/QuemSomos';
import Informacoes from '../components/Informacoes';
import { products as localProducts } from '../data/products';
import SugestoesDedicatorias from '../components/SugestoesDedicatorias';

const HomePage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Carrega os produtos diretamente do arquivo local
    setProducts(localProducts);
    setLoading(false);
  }, []);

  // Criamos uma lista de 100 itens para desenhar a grade de logos no fundo
  const bgLogos = Array.from({ length: 100 });

  return (
    <div data-testid="home-page">
      {/* Fundo fixo com logos espaçadas usando CSS Flexbox */}
      <div className="fixed inset-0 z-[-1] bg-[#E8DCC8] overflow-hidden pointer-events-none">
        <div className="w-full h-full flex flex-wrap content-start justify-evenly gap-12 sm:gap-24 p-8 sm:p-12 opacity-20">
          {bgLogos.map((_, i) => (
            <img
              key={i}
              src={`${process.env.PUBLIC_URL}/images/logo-sem-fundo.png`}
              alt=""
              className="w-24 h-24 sm:w-40 sm:h-40 object-contain"
            />
          ))}
        </div>
      </div>

      {/* Hero Banner */}
      <HeroBanner />

      {/* Products Section - Fundo bege com logo repetida e fixa */}
      <section className="relative py-12 md:py-16 bg-transparent">
        <div className="max-w-7xl mx-auto px-4">
          {loading ? (
            <div className="text-center py-12">
              <div className="inline-block w-8 h-8 border-4 border-[#8B4513] border-t-transparent rounded-full animate-spin" />
              <p className="mt-4 text-[#6B5344]">Carregando cestas...</p>
            </div>
          ) : (
            <ProductGrid products={products} />
          )}
        </div>
      </section>

      {/* Sugestões de Dedicatórias */}
      <SugestoesDedicatorias />

      {/* Quem Somos Section */}
      <QuemSomos />

      {/* Informações Section */}
      <Informacoes />
    </div>
  );
};

export default HomePage;
